import useGlobalState from '@components/Hooks/useGlobalState';
import 'altcha';
import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

interface Props {
  show: boolean,
  verify: (token: string | null) => void
}

const ContactAdminCaptcha: React.FC<Props> = (props) => {

  const [store,] = useGlobalState();

  useEffect(() => {
    setTimeout(() => {
      const widget = document.querySelector('altcha-widget');
      widget?.addEventListener('verified', (ev) => {
        // See enum State above
        const e = ev as unknown as { detail: { payload: string } };
        props.verify(e.detail.payload);
      });
    }, 1);
  }, [props.show, store.requested])

  return (!store.requested && props.show) ? (
    <Row>
      <Col xs={12}>
        <Form.Group style={{ marginTop: 14 }} className='form-group'>
          {/* ALTCHA WebComponent */}
          <altcha-widget challenge="/api/users/do/challenge"></altcha-widget>
        </Form.Group>
      </Col>
    </Row>
  ) : null;
}

export default ContactAdminCaptcha;